<template>
    <div>
        <div class="row pe-3 mt-4 ps-3" v-if="success">
            <div
                class="col-xl-8 col-lg-6 col-md-5 offset-xl-2 offset-md-0 offset-lg-1 offset-sm-2 col-sm-8 offset-1 col-10 success p-2">
                <i class="fa fa-check-circle"></i>&nbsp; Password successfully updated
            </div>
        </div>
        <div class="login-section row pe-3 ps-3">

            <div
                class="col-xl-3 col-lg-4 col-md-5 offset-xl-2 offset-md-0 offset-lg-1 offset-sm-2 col-sm-8 offset-1 col-10">
                <h2 class="register-now pb-3">Log in to your account</h2>
                <div class=" login-form">
                    <login-form 
                        :rememberMe="true" 
                        :displayRegisterNow="false" 
                        :redirect-uri="redirectUri"
                        :showPlaceholders="false"
                        :showPasswordToggle="true"
                        :enableInlineValidation="true"  
                        :hideInfoTooltip="true"
                        >
                        <template v-slot:username>
                            <label for="username" class="pt-0 mt-0 py-1">
                                <strong>Username (Email)</strong>
                            </label>
                        </template>
                        <template v-slot:password>
                            <label for="password" class="pt-0 mt-0 py-1">
                                <strong>Password</strong>
                            </label>
                        </template>
                    </login-form>
                </div>
            </div>

            <div
                class="offset-1 col-10 offset-sm-2 col-sm-8 offset-md-1 col-md-5 offset-lg-1 col-lg-4 offset-xl-1 col-xl-4 pt-3 pt-md-0">
                <h2 class="register-now">Don't have an account yet?</h2>
                <p>
                    Simply register for our site and you will gain access to our secure sections to start
                    your loan process as well as retrieve your personal mortgage documents.
                </p>
                <a class="btn btn-primary pmbtn" href="/registernow" role="button">Register Now</a>
            </div>
        </div>
    </div>
</template>

<script>
import utilitiesMixin from '../../../mixins/Utilities';

export default {
    name: 'login-section',
    analyticsCategory: 'Login Section',
    mixins: [utilitiesMixin],
    props: {
        redirectUri: { type: String, default: '' }
    },
    methods: {
        doRegisterNow() {
            window.scrollTo(0, 0);
            this.utilities.navigation.doNav('registernow', this.$route.name, this.$options.analyticsCategory);
        }
    },
    data() {
        return {
            success: false
        }
    },
    mounted: function () {
        this.success = this.$route.query.success
    }
};
</script>

<style lang="scss">
.login-section {
    padding-top: 2.2rem;
    padding-bottom: 5.5rem;

    .login-form {
        padding: 2%;
        background-color: #e7e7e7;
    }

    h2.register-now {
        color: #00476b !important;
    }

    .btn-primary.pmbtn,
    .btn-primary.pmbtn:hover
    {
        text-decoration: none;
    }
}

.success {
    background: #D1E7DD 0% 0% no-repeat padding-box;
    border: 1px solid #BADBCC;
    border-radius: 4px;
    opacity: 1;
    color: #0F5132;
}
</style>